export const HASH_HIGHLIGHT_CLASSES = 'ring-2 ring-inset ring-border-focus';

export const settingsSectionCardClasses = 'p-5 shadow-none hover:shadow-none @md:p-8';
